export const darkTheme = {
  primary: '#667eea',
  secondary: '#764ba2',
  background: '#1a1a1a',
  surface: '#2a2a2a',
  surfaceLight: '#333333',
  border: '#444444',
  text: '#ffffff',
  textSecondary: '#cccccc',
  textMuted: '#888888',
  success: '#52c41a',
  warning: '#faad14',
  error: '#ff4d4f',
  info: '#1890ff',
  gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  gradientDark: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)',
};

export const lightTheme = {
  primary: '#667eea',
  secondary: '#764ba2',
  background: '#ffffff',
  surface: '#f5f5f5',
  surfaceLight: '#fafafa',
  border: '#e0e0e0',
  text: '#1a1a1a',
  textSecondary: '#4a4a4a',
  textMuted: '#888888',
  success: '#52c41a',
  warning: '#faad14',
  error: '#ff4d4f',
  info: '#1890ff',
  gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  gradientLight: 'linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%)',
};

export type Theme = typeof darkTheme;
